/**
 * Vista: Lista de Pólizas de Garantía
 * Formato: AMX-PVTA-FR-03
 */

import posventaService from '../services/posventa.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Pólizas de Garantía</h2>
          ${permisos.canCreate('polizas') ? `<button class="btn btn-primary" onclick="router.navigate('/posventa/polizas/nueva')">
            + Nueva Póliza
          </button>` : ''}
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Total Pólizas</div>
          </div>
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statVigentes" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Vigentes</div>
          </div>
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statPorVencer" style="font-size: 1.5rem; font-weight: bold; color: var(--warning);">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Por Vencer (30 días)</div>
          </div>
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statVencidas" style="font-size: 1.5rem; font-weight: bold; color: var(--danger);">-</div>
            <div style="color: var(--text-muted); font-size: 0.875rem;">Vencidas</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="busqueda" class="form-input" placeholder="Num. Serie, Propietario..." />
          </div>
          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="vigenteFilter" class="form-input">
              <option value="">Todos</option>
              <option value="true">Vigentes</option>
              <option value="false">Vencidas</option>
            </select>
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.polizasListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Propietario</th>
                <th class="tbl-hide-mobile">Fecha Entrega</th>
                <th class="tbl-hide-mobile">Vencimiento</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="polizasTableBody">
              <tr><td colspan="9" style="text-align: center; padding: 2rem;">Cargando...</td></tr>
            </tbody>
          </table>
        </div>

        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('polizas')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.polizasListView = this;
    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarPolizas();
      }, 500);
    });

    document.getElementById('vigenteFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.vigente;
      } else {
        this.filters.vigente = e.target.value === 'true';
      }
      this.currentPage = 1;
      this.cargarPolizas();
    });

    await this.cargarEstadisticas();
    await this.cargarPolizas();
  },

  async cargarEstadisticas() {
    try {
      const response = await posventaService.estadisticasGenerales();
      const stats = response.data?.polizas || response.polizas || {};
      document.getElementById('statTotal').textContent = stats.total || 0;
      document.getElementById('statVigentes').textContent = stats.vigentes || 0;
      document.getElementById('statPorVencer').textContent = stats.por_vencer || 0;
      document.getElementById('statVencidas').textContent = stats.vencidas || 0;
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarPolizas() {
    try {
      const params = { page: this.currentPage, limit: this.limit, ...this.filters };
      const response = await posventaService.listarPolizas(params);
      // La API devuelve { success, data: [...], pagination: {...} }
      const polizas = Array.isArray(response.data) ? response.data : [];
      const pagination = response.pagination || { page: 1, totalPages: 1 };

      this.renderPolizas(polizas);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar pólizas');
      console.error(error);
      this.renderPolizas([]);
    }
  },

  renderPolizas(polizas) {
    const tbody = document.getElementById('polizasTableBody');
    if (!polizas || polizas.length === 0) {
      tbody.innerHTML = '<tr><td colspan="9" style="text-align: center; padding: 2rem;">No se encontraron pólizas</td></tr>';
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const estadoBadge = (p) => `<span class="badge ${p.estado_garantia === 'vigente' ? 'badge-success' : 'badge-danger'}">${p.estado_garantia === 'vigente' ? 'Vigente' : 'Vencida'}${p.dias_restantes > 0 && p.dias_restantes <= 30 ? ` (${p.dias_restantes} días)` : ''}</span>`;
    const acciones = (p) => p.completada
      ? `${permisos.canView('polizas') ? `<button class="btn btn-sm btn-primary" onclick="router.navigate('/posventa/polizas/${p.id}')">Ver</button>` : ''}`
      : `${permisos.canEdit('polizas') ? `<button class="btn btn-sm btn-primary" onclick="router.navigate('/posventa/polizas/${p.id}')">Editar</button>` : ''}
         ${permisos.canDelete('polizas') ? `<button class="btn btn-sm btn-danger" onclick="window.polizasListView.eliminarPoliza(${p.id}, '${p.num_serie}')">Eliminar</button>` : ''}`;

    tbody.innerHTML = polizas.map(p => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.polizasListView.toggleRow(${p.id})">&#9654;</button>
        </td>
        <td><strong>${p.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${p.modelo || '-'}</td>
        <td class="tbl-hide-mobile">${p.propietario}</td>
        <td class="tbl-hide-mobile">${fechaFmt(p.fecha_entrega)}</td>
        <td class="tbl-hide-mobile">${fechaFmt(p.fecha_fin_garantia)}</td>
        <td class="tbl-hide-mobile">${estadoBadge(p)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(p)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-poliza-${p.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Modelo</dt><dd>${p.modelo || '-'}</dd>
            <dt>Propietario</dt><dd>${p.propietario}</dd>
            <dt>Fecha Entrega</dt><dd>${fechaFmt(p.fecha_entrega)}</dd>
            <dt>Vencimiento</dt><dd>${fechaFmt(p.fecha_fin_garantia)}</dd>
            <dt>Estado</dt><dd>${estadoBadge(p)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(p)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;
    if (totalPages <= 1) { container.innerHTML = ''; return; }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center;">';
    html += `<button class="btn btn-sm btn-secondary" onclick="window.polizasListView.cambiarPagina(${page - 1})" ${page === 1 ? 'disabled' : ''}>Anterior</button>`;
    html += `<span style="padding: 0.5rem;">Página ${page} de ${totalPages}</span>`;
    html += `<button class="btn btn-sm btn-secondary" onclick="window.polizasListView.cambiarPagina(${page + 1})" ${page === totalPages ? 'disabled' : ''}>Siguiente</button>`;
    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarPolizas();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('vigenteFilter').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarPolizas();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-poliza-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  async eliminarPoliza(id, numSerie) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar la póliza del tractor <strong>${numSerie}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await posventaService.eliminarPoliza(id);
          toast.success('Póliza eliminada exitosamente');
          this.cargarEstadisticas();
          this.cargarPolizas();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar póliza');
          console.error(error);
        }
      }
    );
  }
};
